import React from "react"
import { useSelector } from "react-redux"
import { IoEyeSharp } from "react-icons/io5";
import { FaEdit } from "react-icons/fa";
import { RiDeleteBin6Line } from "react-icons/ri";
import { useGetVoyageursQuery } from "actions/Voyageurservices";

const CadreTableau = ({ showTableBody }) => {
    const userId = useSelector((state) => state.auth.user_id);
    const { data: voyageursData } = useGetVoyageursQuery( userId )
    const voyageurs = voyageursData?.data || [];
    console.log({ voyageurs });


    return (
        <table className="table">
                    <thead className="table-light table">
                            <tr>
                                <th>Prénom et nom</th>
                                <th>Adresse e-mail</th>
                                <th>Numéro de Téléphone</th>
                                <th>Date début séjour</th>
                                <th>Date fin séjour</th>
                                <th>Adresse</th>
                                <th>Status</th>
                                <th>Actions</th>
                            </tr>
                    </thead>
                    {showTableBody && (
                        <tbody>
                            {voyageurs.map((voyageur, index) => (
                                <tr key={index}>
                                    <td>{voyageur.prenom} {voyageur.last_name}</td>
                                    <td>{voyageur.nom}</td>
                                    <td>{voyageur.telephone}</td>
                                    <td>{voyageur.date_debut_sejour}</td>
                                    <td>{voyageur.date_fin_sejour}</td>
                                    <td>{voyageur.adresse}</td>
                                    <td>{voyageur.statut_reservation}</td>
                                    <td>
                                        <IoEyeSharp />
                                        <RiDeleteBin6Line/>
                                        <FaEdit/>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    )}
                </table>


    )
}

export default CadreTableau